import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modals: [
    {
      id: "modal-need-help",
      open: false,
    },
    {
      id: "modal-new-project",
      open: false,
    },
    {
      id: "add-writing-expression",
      open: false,
    },
    {
      id: "verify-closing-modal",
      open: false,
    },
    {
      id: "duplicate-writing-modal",
      open: false,
    },
    {
      id: "create-compte-modal",
      open: false,
    },
    {
      id: "delete-compte-modal",
      open: false,
    },
    {
      id: "modify-budget-modal",
      open: false,
    },
    {
      id: "open-budget-modal",
      open: false,
    },
    {
      id: "create-category-check-modal",
      open: false,
    },
    {
      id: "delete-category-check-modal",
      open: false,
    },
    {
      id: "dnd-category-check-modal",
      open: false,
    },
    {
      id: "modify-serie",
      open: false,
    },
    { id: "dnd-horizontal-check-modal", open: false },
    { id: "dnd-special-modal", open: false },
    { id: "assign-plan-compta-modal", open: false },
    { id: "assign-plan-compta-confirm-modal", open: false },
    { id: "edit-serie-confirmation-modal", open: false },
    { id: "delete-serie-confirmation-modal", open: false },
    { id: "delete-confirmation-modal", open: false },
    { id: "edit-duplicated-element-confirmation-modal", open: false },
    { id: "delete-duplicated-element-confirmation-modal", open: false },
    { id: "linking-modal", open: false },
    { id: "linking-confirm-close-modal", open: false },
    { id: "linking-delete-confirm-modal", open: false },
    { id: "linking-delete-all-confirm-modal", open: false },
    { id: "linking-deactivate-confirm-modal", open: false },
    { id: "tresorerie-lock-success-modal", open: false },
    { id: "tresorerie-lock-error-modal", open: false },
    { id: "resultat-lock-success-modal", open: false },
    { id: "resultat-lock-error-modal", open: false },
    { id: "dnd-restriction-modal", open: false },
    { id: "treso-unlock-confirm-modal", open: false },
    { id: "resultat-unlock-confirm-modal", open: false },
    { id: "import-ofx-modal", open: false },
    { id: "delete-imported-category-modal", open: false },
    { id: "export-type-modal", open: false },
    { id: "export-synthesis-result-modal", open: false },
    { id: "export-synthesis-treso-modal", open: false },
    { id: "export-writing-list-modal", open: false },
    { id: "export-writing-filter-modal", open: false },
    { id: "export-month-end-bilan-modal", open: false },
    { id: "show-pointed-sums-modal", open: false },
    { id: "month-end-balance-sheet-items-modal", open: false },
    { id: "project-ready-actions-modal", open: false },
  ],
};

const slice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    openModal: (state, action) => {
      const { id, data } = action.payload;
      const index = state.modals.findIndex((modal) => modal.id === id);
      state.modals[index].open = true;
      state.modals[index].data = data;
    },
    closeModal: (state, action) => {
      const id = action.payload;
      const index = state.modals.findIndex((modal) => modal.id === id);
      state.modals[index].open = false;
    },
  },
});

export const reducer = slice.reducer;

export const openModal = (id, data) => (dispatch) => {
  dispatch(slice.actions.openModal({ id, data }));
};

export const closeModal = (id) => (dispatch) => {
  dispatch(slice.actions.closeModal(id));
};

export default slice;
